import { NgModule } from '@angular/core';
import { ConfigAlertComponent } from './config-alert/config-alert.component';
import { AuthGuard } from '../../Guards/AuthGuard';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: 'configAlert', component: ConfigAlertComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConfigsRoutingModule {
}
